// extracted by mini-css-extract-plugin
export default {"Wrapper":"WorkPermitsView_Wrapper__ZIDIz"};